import React from "react";
import RequestList from "../../components/requests";
import { ISortOption } from "../../components/sortDropdown";
import ISortByType from "../../../types/services/ISortByType";
import SortDropdown from "../../components/sortDropdown";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import { Row, Button, Col } from "reactstrap";
import * as modalActions from "../../../utils/actions/modals";
import * as commonActions from "../../../utils/actions/common";
import { connect } from "react-redux";
import { serviceCaller, ServiceCallerProps } from "../../composition";
import { isCurrentUserCollaborator } from "../../../utils/roleCheck";

interface Props extends ServiceCallerProps {
  t: (str: string, vars?: any) => string;
  history: any;
  toggleCreateRequestModal: () => void;
  hideSelection: () => void;
}

interface State {
  sortBy: ISortByType;
  sortAsc: boolean;
}

const sortOptions: ISortOption[] = [
  { key: "CREATED", show: "Created", colName: "createdOn" },
  { key: "USER", show: "Author", colName: "userName" },
];

class RequestListContainer extends React.Component<Props, State> {
  state = {
    sortBy: sortOptions[0],
    sortAsc: false,
  };

  sortChanged = (newOption: ISortOption) => {
    this.setState({
      sortBy: newOption,
    });
  };

  changeSortOrder = () => {
    this.setState({
      sortAsc: !this.state.sortAsc,
    });
  };

  componentDidMount() {
    this.props.hideSelection();
  }

  render() {
    return (
      <main className={s.main}>
        <div className={s.container}>
          <Row className={s.marginBot}>
            <Col
              xs={10}
              md={6}
              key={"div-sort"}
              className={s.sortContainer + " " + s.colMargin}
            >
              <SortDropdown
                options={sortOptions}
                sortChanged={this.sortChanged}
              />
            </Col>
            <Col xs={1} className={s.colMargin}>
              <div
                onClick={() => this.changeSortOrder()}
                className={s.arrowContainer}
              >
                {this.state.sortAsc && <div className={s.arrowUp} />}
                {!this.state.sortAsc && <div className={s.arrowDown} />}
              </div>
            </Col>
            {isCurrentUserCollaborator(this.props.currentCharity) && (
              <Col>
                <div className={s.actions}>
                  <Button
                    className={s.button}
                    onClick={this.props.toggleCreateRequestModal}
                  >
                    New Request
                  </Button>
                </div>
              </Col>
            )}
          </Row>

          <RequestList
            sortBy={this.state.sortBy}
            sortAsc={this.state.sortAsc}
          />
        </div>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  toggleCreateRequestModal: () => {
    dispatch(modalActions.toggleCreateRequestModal());
  },
  hideSelection: () => {
    dispatch(commonActions.hideSelection());
  },
});

export default serviceCaller(
  connect<Props>(null, mapDispatchToProps)(withStyles(s)(RequestListContainer))
);
